import {Dto, DtoWithId} from "@mango/core";
import {Company} from "./company";
import {School} from "./school";


@Dto({fullName: "AccessMonitor.Logic.Visitor"})
export class Visitor extends DtoWithId {
  registerTime: Date;
  unregisterTime: Date;
  name: string;
  company: Company;
  meetingPerson: string;
  totalDurationMin: number;
  school: School;
  other: string;
}
